// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ModalComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector : 'modal',
    styleUrls: [],
    template : '<div #modal id="{{label}}_modal_root" class="modal" tabindex="-1" role="dialog" [attr.aria-labelledby]="label" [attr.aria-describedby]="label + \'_body\'" aria-hidden="true">\n    <div class="modal-dialog {{customClass}}" role="document">\n        <div class="modal-content">\n            <input type="button" style="height: 0px; padding: 0px; line-height: 0px; border: none; display: block; margin: 0px; min-height: 0px;" title="button" />\n            <div class="modal-header">\n                <h2 class="modal-title" id="{{label}}" title="{{title}}">{{title}}</h2>\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n                <span aria-hidden="true">&times;</span>\n                </button>\n            </div>\n            <div class="modal-body" id="{{label}}_body">\n                <ng-content select="section"></ng-content>\n            </div>\n            <div class="modal-footer">\n                <ng-content select="footer"></ng-content>\n            </div>\n            <input type="button" style="height: 0px; padding: 0px; line-height: 0px; border: none; display: block; margin: 0px; min-height: 0px;" title="button" /> \n        </div>\n    </div>\n</div>\n'
})
export class ModalComponent {

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _onClose = null; //Callback for when the dialog is closed

    //==================================
    // constructor
    //==================================
    constructor(){}

    @ViewChild('modal') modal;

    @Input('title') title;
    @Input('label') label;  //CAS: This value is used to generate ids as well as aria-labelled by refereces that read from within the modal.html markup
    @Input('customClass') customClass; //CAS: Added so I could make the dlg bigger: <modal #dlgNewResource title="New Resource Concern" label="dlgNewResource" customClass="rm-ui-popup-new-resource"> ...
    
    //By default, popups were originally created in the 'body'.  However, we want these to be appended to an element that lies within the 
    //content it is relevant to.  This allows them to be removed automatically when the user navigates away from the page.
    @Input('containerId') containerId; 

    //Use to track the base element do we can remove it on close
    modalRoot = null;

    topTabElement = null;
    bottomTabElement = null;
    topTabReset = null;
    bottomTabReset = null;

    //==================================
    // ngAfterViewInit
    //==================================
    ngAfterViewInit(){

        //Validation
        if (!this.label) { throw("The 'label' property is required on modals in order to set id values"); }


        //Formulate the id for this control
        this.modalRoot = this.label + "_modal_root";

        //Remove any previous instances of this control that have gotten left over
        //This shouldn't happen, but in the odd chance a popup was left in the "body" and we got navigated
        //to a new page, we need to remove this element to avoid duplication
        var elOld$ = $("#" + this.modalRoot);
        if (elOld$) { elOld$.remove(); }

        //Create the popup in the app
        var elContainer = this.containerId ? document.getElementById(this.containerId) : document.body;
        if (!elContainer) { throw("Cannot find container element: ", this.containerId); }

        //Append the markup for this component into the target container
        $(this.modal.nativeElement).appendTo(elContainer);

        //Steve's stuff
        let tabables = $("input, select, *[tabindex], button, a",this.modal.nativeElement);
        this.topTabElement = tabables[1];
        this.bottomTabElement = tabables[tabables.length - 2];
        this.topTabReset = tabables[0];
        this.bottomTabReset = tabables[tabables.length - 1];
        $(this.topTabReset).on('focus', () => {
            $(this.bottomTabElement).get(0).focus();
        });
        $(this.bottomTabReset).on('focus', () => {
            $(this.topTabElement).get(0).focus();
        });

        //This is the event that bootstrap firesafter finishing its "open transition" --CAS
        // OnOpened
        $(this.modal.nativeElement).on('shown.bs.modal', () => {

            //Move the popup markup to the body so it is above the backdrop
            $(this.modal.nativeElement).appendTo("body");
            
            //Check to see if a custom start element is defined
            var firstFocus$ = $("[data-first-focus]", this.modal.nativeElement);

            if (firstFocus$.length > 0){
                //Default first element indicated
                firstFocus$[0].focus();
            }
            else{
                //No start element indicated, just default to the first one
                $(this.topTabElement).get(0).focus();
            }
        });

        //OnClosed
        $(this.modal.nativeElement).on('hidden.bs.modal', () => {
            
            //var elParent = this.containerId ? document.getElementById(this.containerId) : document.body;
            //Move the popup markup to the body so it is above the backdrop
            var elContainer$ = this.containerId ? $("#" + this.containerId) : document.body;

            //If the destination div is not available, then simply remove the popup element
            //(this can happen in cases where the page that owns the popup has been navigated away from before this
            //code finishes its execution, so the missing popup instance container is presumed to indicate this condition).
            if (elContainer$.length == 0) {
                $(this.modal.nativeElement).remove();
            }
            else {
                $(this.modal.nativeElement).appendTo(elContainer$);
            }

            if (this._onClose){
                this._onClose();
            }
        })
        
    };

    //==================================
    // Open
    //==================================
    Open(onClose){
        this._onClose = onClose || null;
        $(this.modal.nativeElement).modal( 'show' );
    }

    //==================================
    // Close
    //==================================
    Close(){
        $(this.modal.nativeElement).modal( 'hide' );
    }
}